var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMentionBro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 494.966,
    height: 419.864,
    viewBox: "0 0 494.966 419.864",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mention-bro",
    transform: "translate(-65.187 -110.794)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-268",
    transform: "translate(220.07 520.264)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13247",
    "data-name": "Path 13247",
    d: "M513.462,412.969c0,2.408-76.178,4.353-170.041,4.353s-170.041-1.945-170.041-4.353,76.178-4.339,170.041-4.339S513.462,410.575,513.462,412.969Z",
    transform: "translate(-173.38 -408.63)",
    fill: "#2e353a",
    opacity: 0.27
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubbles--inject-268",
    transform: "translate(256.813 121.17)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4632",
    "data-name": "Rectangle 4632",
    width: 177.782,
    height: 80.464,
    rx: 6.62,
    transform: "translate(0.027)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13248",
    "data-name": "Path 13248",
    d: "M200.41,164v29.043l16.2-18.65",
    transform: "translate(-200.383 -97.684)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13249",
    "data-name": "Path 13249",
    d: "M369.207,115.25H209.382a8.992,8.992,0,0,0-8.992,9.005v86.354l12.95-14.9H369.207a8.992,8.992,0,0,0,8.992-9.005V124.255a8.992,8.992,0,0,0-8.992-9.005Z",
    transform: "translate(-200.39 -115.25)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13250",
    "data-name": "Path 13250",
    d: "M369.207,115.25H209.382a8.992,8.992,0,0,0-8.992,9.005v86.354l12.95-14.9H369.207a8.992,8.992,0,0,0,8.992-9.005V124.255a8.992,8.992,0,0,0-8.992-9.005Z",
    transform: "translate(-200.39 -115.25)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13251",
    "data-name": "Path 13251",
    d: "M332.259,149.4H217.46a3.21,3.21,0,0,1-3.21-3.21h0a3.21,3.21,0,0,1,3.21-3.2h114.8a3.21,3.21,0,0,1,3.21,3.2h0A3.21,3.21,0,0,1,332.259,149.4Z",
    transform: "translate(-195.396 -105.254)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13252",
    "data-name": "Path 13252",
    d: "M332.259,160.237H217.46a3.21,3.21,0,0,1-3.21-3.21h0a3.21,3.21,0,0,1,3.21-3.2h114.8a3.21,3.21,0,0,1,3.21,3.2h0A3.21,3.21,0,0,1,332.259,160.237Z",
    transform: "translate(-195.396 -101.348)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_214",
    "data-name": "Ellipse 214",
    cx: 11.536,
    cy: 11.536,
    r: 11.536,
    transform: "translate(16.936 6.326)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4633",
    "data-name": "Rectangle 4633",
    width: 177.782,
    height: 80.464,
    rx: 6.62,
    transform: "translate(0.027 108.894)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13253",
    "data-name": "Path 13253",
    d: "M200.41,244.04V273.1l16.2-18.664",
    transform: "translate(-200.383 -68.843)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13254",
    "data-name": "Path 13254",
    d: "M369.207,195.3H209.382a8.992,8.992,0,0,0-8.992,8.992v86.367L213.34,275.7H369.207A8.992,8.992,0,0,0,378.2,266.7V204.292a8.992,8.992,0,0,0-8.992-8.992Z",
    transform: "translate(-200.39 -86.406)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13255",
    "data-name": "Path 13255",
    d: "M369.207,195.3H209.382a8.992,8.992,0,0,0-8.992,8.992v86.367L213.34,275.7H369.207A8.992,8.992,0,0,0,378.2,266.7V204.292a8.992,8.992,0,0,0-8.992-8.992Z",
    transform: "translate(-200.39 -86.406)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13256",
    "data-name": "Path 13256",
    d: "M332.259,229.437H217.46a3.21,3.21,0,0,1-3.21-3.2h0a3.21,3.21,0,0,1,3.21-3.21h114.8a3.21,3.21,0,0,1,3.21,3.21h0a3.21,3.21,0,0,1-3.21,3.2Z",
    transform: "translate(-195.396 -76.414)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13257",
    "data-name": "Path 13257",
    d: "M332.259,240.277H217.46a3.21,3.21,0,0,1-3.21-3.2h0a3.21,3.21,0,0,1,3.21-3.21h114.8a3.21,3.21,0,0,1,3.21,3.21h0a3.21,3.21,0,0,1-3.21,3.2Z",
    transform: "translate(-195.396 -72.508)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_215",
    "data-name": "Ellipse 215",
    cx: 11.536,
    cy: 11.536,
    r: 11.536,
    transform: "translate(16.936 115.206)",
    fill: "#b5b5b5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-268",
    transform: "translate(65.187 186.088)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13258",
    "data-name": "Path 13258",
    d: "M109.82,320.293c-.122,0-.667-8.529-.639-9.073.313-6.3,4.639-18.3,11.481-20.119a8.352,8.352,0,0,1,10.23,7.087c.789,4.924-2.421,10.175-5.673,13.6C121.382,315.763,109.82,320.293,109.82,320.293Z",
    transform: "translate(-41.63 -116.886)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13259",
    "data-name": "Path 13259",
    d: "M103.094,295.554c-.122,0,.626-8.516.735-9.06,1.279-6.176,7.373-17.385,14.392-18.147a8.366,8.366,0,0,1,9.046,8.556c0,4.992-3.931,9.7-7.659,12.569C115.214,292.847,103.094,295.554,103.094,295.554Z",
    transform: "translate(-43.828 -125.013)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13260",
    "data-name": "Path 13260",
    d: "M101.434,267.044c-.122,0,.639-8.516.748-9.06,1.265-6.176,7.359-17.385,14.392-18.147a8.352,8.352,0,0,1,9.033,8.556c0,4.992-3.918,9.686-7.659,12.569C113.554,264.337,101.447,267.044,101.434,267.044Z",
    transform: "translate(-44.426 -135.286)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13261",
    "data-name": "Path 13261",
    d: "M98.564,240.217c-.122,0,.639-8.529.748-9.06,1.265-6.19,7.359-17.385,14.392-18.16a8.366,8.366,0,0,1,9.033,8.57c0,4.979-3.918,9.686-7.659,12.556C110.684,237.5,98.577,240.217,98.564,240.217Z",
    transform: "translate(-45.46 -144.957)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13262",
    "data-name": "Path 13262",
    d: "M90.453,219.614c-.109,0-1.632-8.393-1.673-8.937-.408-6.3,2.517-18.718,9.087-21.3a8.352,8.352,0,0,1,10.978,5.863c1.36,4.8-1.224,10.379-4.081,14.134C101.445,213.792,90.453,219.614,90.453,219.614Z",
    transform: "translate(-48.994 -153.641)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13263",
    "data-name": "Path 13263",
    d: "M114.889,317.973c.136,0-3.578-7.767-3.877-8.23-3.36-5.332-13-13.685-19.847-11.93a8.352,8.352,0,0,0-5.441,11.182c1.714,4.693,7.074,7.7,11.59,9.073C102.646,319.687,114.889,317.973,114.889,317.973Z",
    transform: "translate(-50.304 -114.471)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13264",
    "data-name": "Path 13264",
    d: "M110.063,289.607c.136,0-4.72-7.128-5.074-7.536-4.081-4.775-14.964-11.563-21.425-8.8a8.352,8.352,0,0,0-3.7,11.889c2.394,4.367,8.162,6.53,12.828,7.21C98.161,293.157,110.063,289.607,110.063,289.607Z",
    transform: "translate(-52.621 -123.459)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13265",
    "data-name": "Path 13265",
    d: "M108.573,262.7c.122,0-4.72-7.128-5.074-7.536-4.081-4.775-14.964-11.563-21.439-8.788a8.366,8.366,0,0,0-3.741,11.957c2.408,4.367,8.162,6.53,12.842,7.2C96.67,266.269,108.573,262.718,108.573,262.7Z",
    transform: "translate(-53.184 -133.15)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13266",
    "data-name": "Path 13266",
    d: "M105.963,238.027c.136,0-4.72-7.128-5.074-7.536-4.081-4.775-14.964-11.563-21.425-8.8a8.352,8.352,0,0,0-3.7,11.889c2.394,4.38,8.162,6.53,12.828,7.21C94.061,241.577,105.963,238.027,105.963,238.027Z",
    transform: "translate(-54.098 -142.045)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13267",
    "data-name": "Path 13267",
    d: "M98.6,216.1c.122,0-5.441-6.557-5.877-6.938-4.625-4.285-16.106-9.849-22.269-6.38a8.352,8.352,0,0,0-2.367,12.243c2.87,4.081,8.829,5.6,13.6,5.754C87.155,220.939,98.6,216.109,98.6,216.1Z",
    transform: "translate(-57.055 -149.021)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13268",
    "data-name": "Path 13268",
    d: "M86.222,201.29c.122,0-1.836-8.352-2.013-8.869-2.136-5.945-9.754-16.161-16.827-15.929a8.366,8.366,0,0,0-7.74,9.754c.68,4.952,5.264,9.033,9.373,11.345C73.843,200.31,86.209,201.29,86.222,201.29Z",
    transform: "translate(-59.523 -158.102)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13269",
    "data-name": "Path 13269",
    d: "M134.994,402.005s-1.456-3.333-3.741-9.169-5.441-14.256-8.788-24.486c-1.673-5.115-3.374-10.692-5.033-16.637-.843-2.993-1.605-6-2.435-9.223-.354-1.578-.694-3.17-1.047-4.775s-.6-3.306-.9-4.979a189.092,189.092,0,0,1-2.081-20.718c-.34-7.06-.476-14.2-.653-21.344s-.354-14.256-.925-21.221a145.894,145.894,0,0,0-2.925-20.283A107.466,107.466,0,0,0,100.455,231a147.6,147.6,0,0,0-7.713-15.4c-2.625-4.666-5.319-8.761-7.727-12.379s-4.666-6.666-6.557-9.155c-3.782-4.979-6.149-7.645-6.149-7.645s2.421,2.625,6.326,7.509c1.932,2.462,4.244,5.441,6.8,9.033s5.278,7.618,8.012,12.243a149.735,149.735,0,0,1,8.162,15.331,110.184,110.184,0,0,1,6.543,18.256,147.434,147.434,0,0,1,3.414,20.4c.721,7.033,1.088,14.188,1.36,21.33s.612,14.256,1.1,21.235a188.969,188.969,0,0,0,2.476,20.3c.34,1.619.544,3.2.966,4.8s.775,3.183,1.156,4.748c.843,2.979,1.7,6.081,2.6,8.978,1.755,5.836,3.564,11.318,5.333,16.324,3.51,10.066,6.8,18.31,9.209,24.051s3.891,8.924,3.891,8.924a2.489,2.489,0,0,1-4.5,2.095h0Z",
    transform: "translate(-54.915 -154.523)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13270",
    "data-name": "Path 13270",
    d: "M141.941,312.738c-.122,0,1.8-8.366,1.972-8.883,2.095-5.945,9.658-16.215,16.718-16.025a8.352,8.352,0,0,1,7.795,9.7c-.639,4.952-5.2,9.073-9.291,11.413C154.266,311.691,142.023,312.738,141.941,312.738Z",
    transform: "translate(-29.827 -117.983)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13271",
    "data-name": "Path 13271",
    d: "M142.521,286.924c-.122,0,3.034-8,3.292-8.475,2.979-5.577,12-14.583,18.949-13.318a8.366,8.366,0,0,1,6.244,10.774c-1.36,4.8-6.516,8.162-10.883,9.862C154.914,287.754,142.535,286.924,142.521,286.924Z",
    transform: "translate(-29.617 -126.204)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13272",
    "data-name": "Path 13272",
    d: "M149,259.114c-.136,0,3.02-8,3.278-8.475,2.979-5.564,12.012-14.569,18.963-13.318a8.366,8.366,0,0,1,6.23,10.787c-1.36,4.788-6.516,8.162-10.883,9.862C161.448,259.957,149,259.114,149,259.114Z",
    transform: "translate(-27.283 -136.225)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13273",
    "data-name": "Path 13273",
    d: "M153.911,232.581c-.136,0,3.02-7.985,3.278-8.475,2.979-5.564,12.012-14.569,18.963-13.3a8.352,8.352,0,0,1,6.23,10.774c-1.36,4.8-6.516,8.162-10.883,9.862C166.277,233.424,153.911,232.581,153.911,232.581Z",
    transform: "translate(-25.513 -145.781)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13274",
    "data-name": "Path 13274",
    d: "M151.844,210.814c-.136,0,.8-8.5.925-9.033,1.36-6.162,7.727-17.235,14.773-17.848a8.366,8.366,0,0,1,8.856,8.747c0,4.992-4.081,9.6-7.917,12.393C164.019,208.352,151.844,210.814,151.844,210.814Z",
    transform: "translate(-26.262 -155.425)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13275",
    "data-name": "Path 13275",
    d: "M146.162,312.368c.122,0-1.238-8.461-1.36-8.978-1.7-6.081-8.57-16.827-15.63-17.1a8.366,8.366,0,0,0-8.42,9.182c.313,4.979,4.6,9.386,8.529,11.984C133.878,310.518,146.148,312.368,146.162,312.368Z",
    transform: "translate(-37.475 -118.537)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13276",
    "data-name": "Path 13276",
    d: "M149.565,283.8c.136,0-2.5-8.162-2.721-8.679-2.612-5.754-11.032-15.331-18.052-14.528a8.366,8.366,0,0,0-6.924,10.352c1.061,4.87,5.972,8.584,10.243,10.556C137.1,283.827,149.552,283.8,149.565,283.8Z",
    transform: "translate(-37.151 -127.814)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13277",
    "data-name": "Path 13277",
    d: "M155.767,257.576c.122,0-2.5-8.162-2.721-8.679-2.6-5.741-11.019-15.317-18.038-14.515a8.366,8.366,0,0,0-6.938,10.379c1.075,4.884,5.972,8.584,10.257,10.556C143.347,257.6,155.753,257.576,155.767,257.576Z",
    transform: "translate(-34.919 -137.258)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13278",
    "data-name": "Path 13278",
    d: "M160.3,233.157c.136,0-2.5-8.162-2.721-8.679-2.612-5.741-11.019-15.331-18.052-14.515A8.352,8.352,0,0,0,132.6,220.3c1.061,4.884,5.972,8.584,10.257,10.556C147.875,233.157,160.3,233.157,160.3,233.157Z",
    transform: "translate(-33.285 -146.058)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13279",
    "data-name": "Path 13279",
    d: "M159.457,210.043c.136,0-3.374-7.849-3.659-8.325-3.224-5.441-12.637-14.025-19.534-12.447a8.352,8.352,0,0,0-5.741,11.046c1.592,4.72,6.87,7.863,11.345,9.359C147.119,211.43,159.457,210.043,159.457,210.043Z",
    transform: "translate(-34.134 -153.565)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13280",
    "data-name": "Path 13280",
    d: "M151.837,192.325c.109,0,.612-8.529.571-9.073-.354-6.312-4.748-18.283-11.59-20.065a8.366,8.366,0,0,0-10.189,7.155c-.762,4.938,2.476,10.162,5.754,13.6C140.234,187.863,151.824,192.311,151.837,192.325Z",
    transform: "translate(-33.941 -162.972)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13281",
    "data-name": "Path 13281",
    d: "M141.809,399.152s-.462-3.6-.993-9.862-1.17-15.208-1.456-25.969c-.15-5.441-.2-11.209-.1-17.385,0-3.1.163-6.2.286-9.522.109-1.605.231-3.238.34-4.87s.381-3.346.558-5.033a192.178,192.178,0,0,1,3.9-20.405c1.673-6.87,3.578-13.766,5.441-20.65s3.7-13.767,5.142-20.623a145.1,145.1,0,0,0,2.952-20.269,107.9,107.9,0,0,0-.653-19.14,146.075,146.075,0,0,0-3.02-16.963c-1.2-5.224-2.6-9.917-3.877-14.066s-2.6-7.727-3.686-10.638c-2.217-5.849-3.727-9.087-3.727-9.087s1.578,3.21,3.918,9.005c1.17,2.9,2.517,6.448,3.931,10.57s2.884,8.815,4.19,14.025a148.359,148.359,0,0,1,3.414,17,109.318,109.318,0,0,1,1.088,19.371,147.541,147.541,0,0,1-2.544,20.6c-1.36,6.938-2.993,13.9-4.72,20.84s-3.469,13.848-4.979,20.677a187.4,187.4,0,0,0-3.4,20.16c-.136,1.646-.381,3.21-.435,4.87s-.163,3.278-.245,4.884c0,3.1-.1,6.312,0,9.345,0,6.108.2,11.876.476,17.195.5,10.651,1.36,19.507,2,25.669s1.183,9.672,1.183,9.672a2.482,2.482,0,0,1-4.911.721v-.068Z",
    transform: "translate(-30.81 -158.757)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13282",
    "data-name": "Path 13282",
    d: "M172.268,430.8h-57.6L98.47,336.47h90Z",
    transform: "translate(-45.489 -100.456)",
    fill: "#2e353a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-268",
    transform: "translate(167.548 110.794)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_216",
    "data-name": "Ellipse 216",
    cx: 125.246,
    cy: 125.246,
    r: 125.246,
    transform: "translate(0.626 164.066)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13283",
    "data-name": "Path 13283",
    d: "M260.641,479.513A125.871,125.871,0,1,1,386.513,353.641,125.871,125.871,0,0,1,260.641,479.513Zm0-250.5A124.633,124.633,0,1,0,385.275,353.641,124.633,124.633,0,0,0,260.641,229.008Z",
    transform: "translate(-134.77 -64.33)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13284",
    "data-name": "Path 13284",
    d: "M217.293,427.621a85.089,85.089,0,0,1-28.567-17.589,78.327,78.327,0,0,1-18.909-28.567A101.916,101.916,0,0,1,163,343.485a90.122,90.122,0,0,1,5.768-32.457,81.021,81.021,0,0,1,15.576-25.846,103.848,103.848,0,0,1,49.815-30.322,111.547,111.547,0,0,1,28.825-3.809,98.947,98.947,0,0,1,23.969,2.857,77.975,77.975,0,0,1,21.52,8.91,71.515,71.515,0,0,1,17.535,14.868,64.807,64.807,0,0,1,11.767,21.344,84.667,84.667,0,0,1,4.285,27.52A76.41,76.41,0,0,1,323.875,375.6a66.943,66.943,0,0,1-17.684,14.324,38.947,38.947,0,0,1-18.868,5.251,20.909,20.909,0,0,1-12.665-4.081,14.705,14.705,0,0,1-6-11.78q-11.644,16.406-31.505,16.406-16.174,0-25.846-11.059t-9.631-27.207a72,72,0,0,1,4.217-24.023,81.4,81.4,0,0,1,11.481-21.765,56.821,56.821,0,0,1,18.242-15.875,47.34,47.34,0,0,1,23.37-6.122,34.008,34.008,0,0,1,16.324,3.986,26.785,26.785,0,0,1,11.359,11.59l1.061-3.455a9.713,9.713,0,0,1,14.964-4.747,6.462,6.462,0,0,1,2.367,5.346,8.746,8.746,0,0,1-.476,2.857L287.7,361.359q-2.857,9.631-2.857,13.209,0,6.067,6.189,6.053,8.08,0,15.875-7.427a54.7,54.7,0,0,0,12.665-19.738,68.615,68.615,0,0,0,4.87-25.506,73.823,73.823,0,0,0-3.333-22.7,54.822,54.822,0,0,0-8.937-17.535,53.692,53.692,0,0,0-13.6-12.134,59.583,59.583,0,0,0-16.773-7.251,73.623,73.623,0,0,0-18.609-2.381,86,86,0,0,0-23.6,3.333,84.707,84.707,0,0,0-22.3,10.053,87.185,87.185,0,0,0-18.732,15.93,70.151,70.151,0,0,0-12.95,22.051,77.647,77.647,0,0,0-4.816,27.533,84.612,84.612,0,0,0,5.945,32.525A61.487,61.487,0,0,0,202.969,400.8,72.844,72.844,0,0,0,226.5,414.521a83.1,83.1,0,0,0,28.363,4.761,101.045,101.045,0,0,0,30.444-4.639,9.085,9.085,0,0,1,3.088-.476,6.911,6.911,0,0,1,5.346,2.2,7.251,7.251,0,0,1,2.027,5.047,6.285,6.285,0,0,1-4.884,6.666,133.164,133.164,0,0,1-37.926,5.822A100.107,100.107,0,0,1,217.293,427.621Zm42.986-53.978a29.682,29.682,0,0,0,10.883-14.964l10.883-38.28-.721-1.551a18.7,18.7,0,0,0-2.489-3.51,38.457,38.457,0,0,0-4.231-4.163,20.975,20.975,0,0,0-6.53-3.564,25.846,25.846,0,0,0-18.909.653,31.165,31.165,0,0,0-8.856,5.768,48.238,48.238,0,0,0-7.2,8.448,56.3,56.3,0,0,0-5.441,10.162,62.571,62.571,0,0,0-3.387,10.991,52.237,52.237,0,0,0-1.2,10.883,53.206,53.206,0,0,0,.422,7.019,31.588,31.588,0,0,0,1.36,6.067,20.406,20.406,0,0,0,2.435,5.047,14.815,14.815,0,0,0,3.564,3.741,15.155,15.155,0,0,0,4.938,2.381,22.743,22.743,0,0,0,6.421.83,29.37,29.37,0,0,0,18.052-5.958Z",
    transform: "translate(-124.6 -55.941)",
    fill: "#9169df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13285",
    "data-name": "Path 13285",
    d: "M354.347,242.87s-4.081,7.591-4.68,8.652-2.789,6.8-2.136,8.162,1.279,2.136,2.571,2.353,2.353,2.571,4.489,2.993a23.005,23.005,0,0,0,4.081.435,2.72,2.72,0,0,0,2.367.422c1.279-.422,2.353-1.061,3.21-4.707a13.6,13.6,0,0,0,.422-5.564l-.381-7.359Z",
    transform: "translate(-58.149 -58.889)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13286",
    "data-name": "Path 13286",
    d: "M360.464,266.862a3.482,3.482,0,0,1-1.823-.544,23.8,23.8,0,0,1-4-.449,6.339,6.339,0,0,1-3.142-1.986,3.6,3.6,0,0,0-1.36-1.007,4.217,4.217,0,0,1-3.061-2.721c-.884-1.755,1.687-8,2.163-8.788.626-1.047,4.625-8.556,4.666-8.638a.707.707,0,0,1,.408-.326.694.694,0,0,1,.517,0l9.93,5.373a.707.707,0,0,1,.354.571l.381,7.346h0a14.093,14.093,0,0,1-.449,5.754c-.843,3.632-1.945,4.639-3.659,5.21a3.019,3.019,0,0,1-.925.2Zm-5.645-22.881c-.979,1.823-3.836,7.169-4.38,8.08-.748,1.238-2.544,6.638-2.122,7.482.68,1.36,1.2,1.85,2.081,2a4.2,4.2,0,0,1,2.054,1.36,5.115,5.115,0,0,0,2.462,1.632,23.467,23.467,0,0,0,3.931.422.707.707,0,0,1,.435.15,2.013,2.013,0,0,0,1.714.313c.939-.313,1.918-.639,2.721-4.217a13.263,13.263,0,0,0,.422-5.278l-.367-7.074Z",
    transform: "translate(-58.335 -59.075)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13287",
    "data-name": "Path 13287",
    d: "M371.389,393.12s-5.809,9.454-5.809,11.74,8,6.489,11.427,8.012,9.522,2.721,14.474,3.428,15.236,2.721,12.243-1.143-21.384-14.039-22.146-15.249a21.429,21.429,0,0,0-3.156-3.074Z",
    transform: "translate(-51.602 -4.749)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13288",
    "data-name": "Path 13288",
    d: "M401.428,418.3a61.69,61.69,0,0,1-8.652-.966l-1.224-.19c-6.91-1.061-11.835-2.231-14.637-3.482-.49-.218-11.835-5.292-11.835-8.625,0-2.408,5.305-11.114,5.9-12.107a.694.694,0,0,1,.9-.245l7.033,3.727a20.5,20.5,0,0,1,3.414,3.306c.326.381,3.319,2.258,6.217,4.081,6.176,3.85,13.848,8.652,15.834,11.128.721.9.9,1.673.517,2.313S403.319,418.3,401.428,418.3ZM371.773,394.2c-2.2,3.646-5.373,9.4-5.373,10.883s5.822,5.074,11.019,7.387c2.721,1.2,7.509,2.326,14.311,3.374l1.211.19c2.5.394,10.121,1.605,10.747.544a1.465,1.465,0,0,0-.408-.775c-1.836-2.3-9.726-7.237-15.494-10.883-4.639-2.9-6.3-3.959-6.638-4.462a20.252,20.252,0,0,0-3.02-2.925Z",
    transform: "translate(-51.782 -4.931)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13289",
    "data-name": "Path 13289",
    d: "M376.54,405.717l2.04,3.047a24.283,24.283,0,0,0,8.679,7.972c5.441,2.938,13.821,6.3,21.14,4.285,12-3.306-18.2-21.52-18.2-21.52S379.438,406.982,376.54,405.717Z",
    transform: "translate(-47.653 -2.45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13290",
    "data-name": "Path 13290",
    d: "M403.824,422.483c-6.04,0-12.243-2.53-16.7-4.979a25.071,25.071,0,0,1-8.924-8.162l-2.041-3.061a.68.68,0,0,1,0-.8.694.694,0,0,1,.8-.19c1.755.762,8.652-3.142,12.991-6.149a.653.653,0,0,1,.735,0c2.272,1.36,22.187,13.6,21.33,19.806-.19,1.36-1.36,2.394-3.292,2.938A18.432,18.432,0,0,1,403.824,422.483Zm-25.765-15.834,1.265,1.918a23.78,23.78,0,0,0,8.434,7.74c5.55,2.993,13.6,6.162,20.65,4.231,2.122-.6,2.258-1.524,2.3-1.823.612-4.448-14.107-14.447-20.31-18.228-2.163,1.442-8.665,5.727-12.338,6.162Z",
    transform: "translate(-47.839 -2.621)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13291",
    "data-name": "Path 13291",
    d: "M379.08,405.13a24.744,24.744,0,0,0,14.093,10.216c9.862,2.816,12.692,2.109,14.8-.707",
    transform: "translate(-46.738 -0.422)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13292",
    "data-name": "Path 13292",
    d: "M402.767,418a37.27,37.27,0,0,1-9.59-1.823,25.152,25.152,0,0,1-14.5-10.529.667.667,0,0,1,.245-.925.694.694,0,0,1,.939.245,24.35,24.35,0,0,0,13.685,9.9c9.617,2.721,12.243,2.04,14.066-.463a.694.694,0,0,1,.952-.136.68.68,0,0,1,.136.952A6.666,6.666,0,0,1,402.767,418Z",
    transform: "translate(-46.918 -0.601)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13293",
    "data-name": "Path 13293",
    d: "M366.13,400.47s10.883,7.795,16.2,7.944",
    transform: "translate(-51.404 -2.101)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13294",
    "data-name": "Path 13294",
    d: "M382.462,409.276h0c-5.441-.15-16.12-7.754-16.569-8.067a.694.694,0,0,1-.15-.952.667.667,0,0,1,.939-.163c.109.082,10.787,7.686,15.821,7.822a.694.694,0,0,1,.667.707.68.68,0,0,1-.707.653Z",
    transform: "translate(-51.589 -2.282)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13295",
    "data-name": "Path 13295",
    d: "M355.718,244.79s9.658,16.011,11.726,19.725,28.132,33.518,38.47,59.174S426.2,372.5,425.775,379.952s-34.362,70.329-34.362,70.329l-7.033-3.714s10.747-59.174,9.522-65.378-39.218-67.853-39.218-67.853-17.793-12.406-25.234-26.894",
    transform: "translate(-64.621 -58.197)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13296",
    "data-name": "Path 13296",
    d: "M367.815,287.013s-5.373,11.576-5.373,13.236,30.2,90.612,38.892,110.88a411.445,411.445,0,0,1,14.474,39.722s3.319,4.081.83,8.271-12.406,7.033-14.474,3.306-22.35-23.126-31.029-42.606-21.1-52.55-28.145-64.956a444.348,444.348,0,0,1-24.812-49.244C309.063,284.116,299.69,260.8,299.69,260.8a94.516,94.516,0,0,0,36.4-4.081c19.045-6.2,27.207-18.079,27.207-18.079s4.843,12.379,6.081,14.773",
    transform: "translate(-75.344 -60.413)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13297",
    "data-name": "Path 13297",
    d: "M354.505,309.114a.476.476,0,0,1-.435-.3l-9.522-24.758a.49.49,0,0,1,.136-.531l10.665-9.141a.49.49,0,0,1,.667,0,.476.476,0,0,1,0,.653l-10.42,8.937,9.4,24.486a.476.476,0,0,1-.258.612Z",
    transform: "translate(-59.191 -47.58)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13298",
    "data-name": "Path 13298",
    d: "M347.13,288.258a.449.449,0,0,1-.313-.122.462.462,0,0,1-.15-.34c0-.068,0-7.536-3.346-12.243-.83-1.211-1.5-2.163-2.054-2.938-1.741-2.476-2.272-3.224-2.585-4.462a14.814,14.814,0,0,1,0-4.367.49.49,0,0,1,.531-.395.462.462,0,0,1,.394.531,14.05,14.05,0,0,0,0,4.013c.272,1.061.735,1.714,2.449,4.149.544.775,1.224,1.728,2.054,2.938,3.02,4.339,3.442,10.57,3.51,12.352l19.33-.748a.49.49,0,0,1,.49.449.449.449,0,0,1-.449.476l-19.806.762Z",
    transform: "translate(-61.352 -51.495)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13299",
    "data-name": "Path 13299",
    d: "M397.843,348.186c-8.611,0-19.548-5.577-20.038-5.822a.469.469,0,0,1,.435-.83c.122.068,12.556,6.407,21.071,5.659a.471.471,0,0,1,.082.939C398.89,348.172,398.373,348.186,397.843,348.186Z",
    transform: "translate(-47.286 -23.356)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13300",
    "data-name": "Path 13300",
    d: "M396.072,354.355h-.109c-7.631-1.918-16.2-8.937-16.569-9.237a.476.476,0,0,1,0-.653.463.463,0,0,1,.653-.068c.082.068,8.774,7.2,16.2,9.046a.463.463,0,0,1,.326.571.449.449,0,0,1-.5.34Z",
    transform: "translate(-46.671 -22.343)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13301",
    "data-name": "Path 13301",
    d: "M345.417,282.15a.476.476,0,0,1-.381-.19.463.463,0,0,1,.122-.653c1.836-1.279,4.748-3.741,4.748-4.952,0-.8-.993-1.755-2.054-2.721A11.7,11.7,0,0,1,345,270.1c-.694-1.619-3.183-7.972-2.721-9.522a.463.463,0,0,1,.585-.3.476.476,0,0,1,.3.6c-.286.83,1.2,5.441,2.653,8.815a10.881,10.881,0,0,0,2.639,3.21c1.265,1.211,2.353,2.245,2.353,3.442,0,2.095-4.625,5.346-5.156,5.713A.49.49,0,0,1,345.417,282.15Z",
    transform: "translate(-60.02 -52.625)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13302",
    "data-name": "Path 13302",
    d: "M311.377,282.188a.463.463,0,0,1-.3-.83l3.809-3.047c3.659-2.911,5.917-10.352,5.945-10.434a.469.469,0,1,1,.9.272c-.1.313-2.381,7.795-6.258,10.883l-3.809,3.047a.449.449,0,0,1-.286.109Z",
    transform: "translate(-71.306 -49.997)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13303",
    "data-name": "Path 13303",
    d: "M403.221,454.234a.476.476,0,0,1-.354-.177,148.553,148.553,0,0,1-13.154-18.963c-5.264-9.414-20.4-35.165-20.568-35.369a44.291,44.291,0,0,1-3.1-9.686c-.1-.517-.163-.993-.231-1.36-.5-3.428-.721-4.843-5.278-7.781s-4.843-8.053-5.224-13.535c-.082-1.292-.177-2.625-.326-3.945-.612-5.441-15.059-29.927-25.6-47.72-2.394-4.081-4.571-7.727-6.339-10.76-9.441-16.242-15.97-37.6-16.038-37.817a.476.476,0,0,1,.313-.585.449.449,0,0,1,.571.313c.068.218,6.57,21.48,15.957,37.613,1.768,3.034,3.945,6.72,6.339,10.76,10.6,17.888,25.1,42.4,25.724,48.088.15,1.36.245,2.721.34,4,.367,5.441.68,10.175,4.788,12.814,4.911,3.156,5.156,4.8,5.7,8.407a9.876,9.876,0,0,0,.218,1.428,43.426,43.426,0,0,0,3.02,9.4c.122.231,15.276,25.982,20.555,35.369a148.356,148.356,0,0,0,13.059,18.813.463.463,0,0,1-.068.653.476.476,0,0,1-.3.041Z",
    transform: "translate(-72.715 -50.369)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13304",
    "data-name": "Path 13304",
    d: "M299.69,260.8s.871,9.631,4.68,12.678,15.236,5.713,30.852,2.721,32.757-16.324,34.28-20.949-6.23-16.6-6.23-16.6-9.005,12.787-34.144,16.977S299.69,260.8,299.69,260.8Z",
    transform: "translate(-75.344 -60.409)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13305",
    "data-name": "Path 13305",
    d: "M322.167,278.362c-9.209,0-15.521-2.136-18.052-4.163-3.986-3.2-4.884-12.733-4.924-13.141a.68.68,0,0,1,.517-.721c.177,0,4.612-1.1,29.492-5.251,24.486-4.081,33.6-16.569,33.7-16.691a.694.694,0,0,1,.558-.286h0a.68.68,0,0,1,.558.313c.816,1.251,7.89,12.433,6.312,17.181-1.673,5.006-19.208,18.351-34.8,21.4A69.892,69.892,0,0,1,322.167,278.362Zm-21.548-16.827c.258,2.095,1.36,9.2,4.353,11.6,3.4,2.721,14.3,5.659,30.295,2.53,15.725-3.074,32.417-16.419,33.777-20.5,1.075-3.238-3.319-11.413-5.659-15.195-2.421,2.9-12.134,12.828-34.008,16.46C309.216,259.807,302.442,261.086,300.619,261.535Z",
    transform: "translate(-75.525 -60.604)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13306",
    "data-name": "Path 13306",
    d: "M413.4,198c-6.217-4.081-54.617-41.789-59.174-43.449s-13.6,0-13.6,0-28.05,3.428-33.927,5.795c-.558.218-13.2,7.482-13.6,7.863-4.557,3.727-24.486,12.9-29.846,24.486-6.081,13.114,47.353,92.067,49.842,98.678s15.535,8.244,27.533,6.584,22.527-4.081,31.22-14.025a30.215,30.215,0,0,0,3.931-6.462,12.487,12.487,0,0,0,.9-8.3c-3.1-12.923-11.019-50.183-16.242-74.818,8.706,5.618,26.812,17.031,37.341,21.058,14.066,5.441,24.826,1.66,24.826-2.9S419.6,202.14,413.4,198Z",
    transform: "translate(-88.649 -90.977)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13307",
    "data-name": "Path 13307",
    d: "M370.9,197.907a60.113,60.113,0,0,1-23.588-7.441s10.76-4.965,11.168-7.455-14.9-.408-12.828-1.238,4.965-2.9,0-2.9A40.961,40.961,0,0,1,334.08,176.4l.558,9.781c4.734,3.061,12.243,7.808,19.779,12.161a206.511,206.511,0,0,0,21.861,9.917S385.378,199.566,370.9,197.907Z",
    transform: "translate(-62.953 -82.84)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13308",
    "data-name": "Path 13308",
    d: "M337.41,282.359l1.537-.218c3.319-1.605,8.937-2.612,14.406-3.972,8.271-2.068-.83-2.068-14.487-9.1S319.821,251.7,307.414,236.8s-17.371-22.35-14.882-24-4.965-1.66-7.863-3.319,4.081-1.646,9.93-7.441-11.182,1.238-12.828.83,1.646-5.795,1.646-5.795l-12,12.406,28.961,49.652,1.66,1.238,1.9,2.721,5.441,11.7c.218.408.367.748.463.979C312.352,282.4,325.411,284.032,337.41,282.359Z",
    transform: "translate(-85.531 -75.388)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13309",
    "data-name": "Path 13309",
    d: "M283.992,177.187c9.155-1.36,34.675,13.2,34.675,13.2-14.025-9.522-26.3-18.446-34.688-22.473l-15.467,10.883-1.061.993C269.246,179.432,276.129,178.3,283.992,177.187Z",
    transform: "translate(-86.961 -85.899)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13310",
    "data-name": "Path 13310",
    d: "M370.9,197.907a60.113,60.113,0,0,1-23.588-7.441s10.76-4.965,11.168-7.455-14.9-.408-12.828-1.238,4.965-2.9,0-2.9A40.961,40.961,0,0,1,334.08,176.4l.558,9.781c4.734,3.061,12.243,7.808,19.779,12.161a206.511,206.511,0,0,0,21.861,9.917S385.378,199.566,370.9,197.907Z",
    transform: "translate(-62.953 -82.84)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13311",
    "data-name": "Path 13311",
    d: "M337.41,282.359l1.537-.218c3.319-1.605,8.937-2.612,14.406-3.972,8.271-2.068-.83-2.068-14.487-9.1S319.821,251.7,307.414,236.8s-17.371-22.35-14.882-24-4.965-1.66-7.863-3.319,4.081-1.646,9.93-7.441-11.182,1.238-12.828.83,1.646-5.795,1.646-5.795l-12,12.406,28.961,49.652,1.66,1.238,1.9,2.721,5.441,11.7c.218.408.367.748.463.979C312.352,282.4,325.411,284.032,337.41,282.359Z",
    transform: "translate(-85.531 -75.388)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13312",
    "data-name": "Path 13312",
    d: "M283.992,177.187c9.155-1.36,34.675,13.2,34.675,13.2-14.025-9.522-26.3-18.446-34.688-22.473l-15.467,10.883-1.061.993C269.246,179.432,276.129,178.3,283.992,177.187Z",
    transform: "translate(-86.961 -85.899)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13313",
    "data-name": "Path 13313",
    d: "M332.024,299.422c-9.169,0-17.426-2.19-19.466-7.631-.6-1.605-4.625-8.162-9.726-16.406-21.67-35.151-44.428-73.458-40.089-82.8,4.081-8.815,16.147-16.093,24.132-20.908a61.213,61.213,0,0,0,5.89-3.809c.49-.394,13.154-7.686,13.835-7.958,5.9-2.381,32.947-5.7,34.1-5.836.34-.068,9.291-1.673,13.957,0,3.02,1.1,23.711,16.759,40.334,29.342,9.005,6.8,16.773,12.705,18.977,14.175,6.938,4.625,9.414,10.8,9.414,15.045a4.761,4.761,0,0,1-2.394,3.836c-4.013,2.721-12.787,3.741-23.357-.3-7.387-2.829-19.847-9.808-36.09-20.242,5.441,25.914,12.91,60.82,15.889,73.227a13.182,13.182,0,0,1-.939,8.761,29.505,29.505,0,0,1-4.081,6.611c-9.087,10.379-20.146,12.665-31.628,14.243a63.941,63.941,0,0,1-8.76.653Zm16.868-144.739a53.532,53.532,0,0,0-7.985.721c-.326,0-28.064,3.442-33.8,5.754-.748.34-12.869,7.319-13.481,7.768a59.074,59.074,0,0,1-6.053,3.9c-7.836,4.734-19.67,11.889-23.588,20.4-4.407,9.522,24.486,56.331,40.007,81.511,5.537,8.978,9.2,14.964,9.849,16.637,2.408,6.421,15.576,7.686,26.8,6.135s22.024-3.768,30.8-13.794a29.029,29.029,0,0,0,3.836-6.312,11.822,11.822,0,0,0,.843-7.836c-3.047-12.678-10.719-48.8-16.242-74.818a.694.694,0,0,1,.286-.707.68.68,0,0,1,.748,0c16.841,10.883,29.71,18.133,37.219,20.99,10.039,3.85,18.5,2.938,22.092.463a3.6,3.6,0,0,0,1.809-2.721c0-3.891-2.313-9.59-8.8-13.916-2.245-1.5-10.026-7.387-19.045-14.215-15.685-11.862-37.151-28.118-39.98-29.152A16.515,16.515,0,0,0,348.892,154.683Z",
    transform: "translate(-88.851 -91.159)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13314",
    "data-name": "Path 13314",
    d: "M281.361,176.17s-4.965,5.441-6.9,7.958c-10.366,13.318-43.354,55.991-43.721,59.433s1.2,5.754,9.264,8.856,62.031-50.972,62.031-50.972",
    transform: "translate(-100.206 -82.923)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13315",
    "data-name": "Path 13315",
    d: "M281.444,176.29l-.694.449c-1.007,1.115-3.183,3.55-4.87,5.55l-25.057,32.866s-.775.871-2,2.313c-9.4,12.529-17.589,23.833-18.092,25.846v.19c-.327,3.251,1.251,5.727,9.277,8.815,1.428.544,4.258-.68,7.972-3.061a15.888,15.888,0,0,1-5.319-2.122c-4.557-2.9-.83-5.8-.83-5.8s5.917,2.367,11.753,3.959c1.211-.911,2.476-1.891,3.768-2.925a28.691,28.691,0,0,1-3.523-2.721c-4.965-4.543-9.1-9.1-9.1-9.1l37.926-52.93Z",
    transform: "translate(-100.207 -82.879)",
    fill: "#fff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13316",
    "data-name": "Path 13316",
    d: "M281.444,176.29l-.694.449c-1.007,1.115-3.183,3.55-4.87,5.55l-25.057,32.866s-.775.871-2,2.313c-9.4,12.529-17.589,23.833-18.092,25.846v.19c-.327,3.251,1.251,5.727,9.277,8.815,1.428.544,4.258-.68,7.972-3.061a15.888,15.888,0,0,1-5.319-2.122c-4.557-2.9-.83-5.8-.83-5.8s5.917,2.367,11.753,3.959c1.211-.911,2.476-1.891,3.768-2.925a28.691,28.691,0,0,1-3.523-2.721c-4.965-4.543-9.1-9.1-9.1-9.1l37.926-52.93Z",
    transform: "translate(-100.207 -82.879)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13317",
    "data-name": "Path 13317",
    d: "M240.82,253.377a2.584,2.584,0,0,1-.9-.15c-7.509-2.9-10.148-5.441-9.7-9.522.367-3.387,27.642-38.905,43.857-59.773,1.932-2.476,6.734-7.768,6.938-7.985a.68.68,0,1,1,1.007.911s-4.979,5.441-6.87,7.917c-26.2,33.709-43.313,56.9-43.531,59.079-.313,2.9,1.034,5.156,8.842,8.162,5.618,2.163,39.735-29.22,61.3-50.836a.683.683,0,1,1,.966.966C297.328,207.48,251.24,253.377,240.82,253.377Z",
    transform: "translate(-100.393 -83.095)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13318",
    "data-name": "Path 13318",
    d: "M353.154,174.35,334.49,186.919c2.721-.381,15.617-4.952,15.617-4.952",
    transform: "translate(-62.805 -83.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13319",
    "data-name": "Path 13319",
    d: "M334.669,187.779a.653.653,0,0,1-.626-.435.667.667,0,0,1,.245-.8l18.677-12.569a.667.667,0,0,1,.939.177.694.694,0,0,1-.19.952l-15.3,10.311c4.693-1.442,11.563-3.863,11.658-3.9a.716.716,0,0,1,.449,1.36c-.531.177-13.046,4.6-15.753,4.979Z",
    transform: "translate(-62.984 -83.758)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_320",
    "data-name": "Line 320",
    y1: 0.762,
    x2: 4.19,
    transform: "translate(289.587 97.247)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13320",
    "data-name": "Path 13320",
    d: "M347.829,180.731a.694.694,0,0,1-.667-.558.68.68,0,0,1,.544-.789l4.19-.762a.694.694,0,0,1,.8.544.68.68,0,0,1-.558.8l-4.19.762Z",
    transform: "translate(-58.242 -82.043)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13321",
    "data-name": "Path 13321",
    d: "M248.223,216a19.821,19.821,0,0,0-8.393,1.592",
    transform: "translate(-96.914 -68.573)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13322",
    "data-name": "Path 13322",
    d: "M240.048,218.5a.692.692,0,0,1-.258-1.36,20.4,20.4,0,0,1,8.706-1.646.68.68,0,0,1,.626.735.694.694,0,0,1-.735.626,19.045,19.045,0,0,0-8.067,1.537A.653.653,0,0,1,240.048,218.5Z",
    transform: "translate(-97.131 -68.757)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13323",
    "data-name": "Path 13323",
    d: "M275.9,203.706s10.488-3.21,13.263-5.346",
    transform: "translate(-83.917 -74.927)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13324",
    "data-name": "Path 13324",
    d: "M276.107,204.571a.687.687,0,1,1-.19-1.36c.1,0,10.393-3.183,13.046-5.224a.68.68,0,0,1,.952.122.694.694,0,0,1-.122.952c-2.857,2.19-13.046,5.319-13.481,5.441A.531.531,0,0,1,276.107,204.571Z",
    transform: "translate(-84.124 -75.112)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13325",
    "data-name": "Path 13325",
    d: "M287.54,197.976s1.714-1.5,2.353-1.5",
    transform: "translate(-79.722 -75.604)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13326",
    "data-name": "Path 13326",
    d: "M287.729,198.837a.707.707,0,0,1-.517-.231.694.694,0,0,1,0-.966,6.189,6.189,0,0,1,2.8-1.66.68.68,0,0,1,.68.68.694.694,0,0,1-.68.68,7.659,7.659,0,0,0-1.9,1.36A.653.653,0,0,1,287.729,198.837Z",
    transform: "translate(-79.911 -75.785)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_321",
    "data-name": "Line 321",
    x1: 1.7,
    y1: 17.48,
    transform: "translate(269.985 85.861)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13327",
    "data-name": "Path 13327",
    d: "M335.121,189.081a.694.694,0,0,1-.68-.612l-1.7-17.48a.684.684,0,0,1,1.36-.136l1.714,17.494a.667.667,0,0,1-.612.735Z",
    transform: "translate(-63.436 -85.06)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13328",
    "data-name": "Path 13328",
    d: "M230.736,229.13s-2.408,9.209,13.032,13.032c7.332,1.809,55.855,13.6,55.855,13.6s4.339-9.3,1.864-9.3-47.217-29.75-47.217-29.75",
    transform: "translate(-100.24 -68.315)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13329",
    "data-name": "Path 13329",
    d: "M237.952,239.306l56.263,14.365,1.5-3.564s-21.194-4.244-34.43-10.883-14.079-4.557-18.623-7.441-.83-5.8-.83-5.8,12.42,4.965,19.045,5.373-2.068-2.476-7.033-7.033c-2.054-1.877-3.959-3.768-5.441-5.319l-17.684,9.277S229,234.967,237.952,239.306Z",
    transform: "translate(-100.246 -67.486)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13330",
    "data-name": "Path 13330",
    d: "M237.952,239.306l56.263,14.365,1.5-3.564s-21.194-4.244-34.43-10.883-14.079-4.557-18.623-7.441-.83-5.8-.83-5.8,12.42,4.965,19.045,5.373-2.068-2.476-7.033-7.033c-2.054-1.877-3.959-3.768-5.441-5.319l-17.684,9.277S229,234.967,237.952,239.306Z",
    transform: "translate(-100.246 -67.486)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13331",
    "data-name": "Path 13331",
    d: "M299.8,256.719h-.163s-48.523-11.848-55.855-13.6c-6.121-1.51-10.271-4.081-12.325-7.5a8.774,8.774,0,0,1-1.2-6.366.694.694,0,0,1,.83-.49.68.68,0,0,1,.476.83h0a7.672,7.672,0,0,0,1.088,5.36c1.864,3.129,5.727,5.441,11.454,6.8,6.8,1.7,49.951,12.243,55.311,13.522,1.673-3.7,2.721-7.291,2.245-7.849h0c-2.585,0-40.062-24.894-47.544-29.927a.694.694,0,0,1-.19-.952.667.667,0,0,1,.939-.177c17.616,11.74,44.632,29.329,46.823,29.669h0a1.36,1.36,0,0,1,1.115.612c1.129,1.782-1.551,7.849-2.408,9.672A.68.68,0,0,1,299.8,256.719Z",
    transform: "translate(-100.419 -68.48)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13332",
    "data-name": "Path 13332",
    d: "M283.2,238.61s15.929,7.455,17.167,9.522,4.081,12.814,4.081,16.133-.408,3.306-2.476,3.306-7.455-7.863-8.693-9.522-4.081-1.66-7.863-4.081a9.141,9.141,0,0,1-4.081-6Z",
    transform: "translate(-81.956 -60.424)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13333",
    "data-name": "Path 13333",
    d: "M302.212,268.433c-1.782,0-4.72-3.55-8.584-8.883-.272-.381-.49-.694-.653-.9a6.013,6.013,0,0,0-2.816-1.578,23.41,23.41,0,0,1-4.884-2.408,9.862,9.862,0,0,1-4.435-6.489,1.031,1.031,0,0,1,0-.2l1.864-9.318a.708.708,0,0,1,.354-.476.666.666,0,0,1,.6,0c2.721,1.251,16.188,7.645,17.467,9.781s4.231,13.073,4.231,16.487S304.729,268.433,302.212,268.433Zm-20-20.31a8.57,8.57,0,0,0,3.823,5.441,22.076,22.076,0,0,0,4.612,2.258,7.087,7.087,0,0,1,3.414,2.04c.163.2.395.517.667.911,4.979,6.883,6.8,8.325,7.482,8.325,1.8,0,1.8,0,1.8-2.625,0-3.21-2.829-13.78-4.081-15.793-.789-1.36-9.971-5.985-16.093-8.883Z",
    transform: "translate(-82.138 -60.605)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_322",
    "data-name": "Line 322",
    y1: 7.686,
    x2: 2.476,
    transform: "translate(194.446 178.214)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13334",
    "data-name": "Path 13334",
    d: "M277.889,247.174a.545.545,0,0,1-.2,0,.667.667,0,0,1-.435-.857l2.476-7.686a.68.68,0,1,1,1.292.422l-2.476,7.686a.694.694,0,0,1-.653.435Z",
    transform: "translate(-83.444 -60.594)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13335",
    "data-name": "Path 13335",
    d: "M371.541,197.852s-4.081,14.066-5.8,22.337S352.51,261.57,352.51,261.57l9.93,6.2s21.929-45.435,26.1-55.393,2.9-17.385-1.238-21.52",
    transform: "translate(-56.312 -77.629)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13336",
    "data-name": "Path 13336",
    d: "M362.62,268.672a.68.68,0,0,1-.354-.109l-9.93-6.2a.68.68,0,0,1-.286-.8c.109-.327,11.59-33.151,13.209-41.272s5.781-22.255,5.781-22.4a.706.706,0,0,1,1.36.381c0,.136-4.149,14.134-5.781,22.282-1.551,7.767-11.549,36.579-13.086,40.96l8.829,5.509c2.721-5.727,21.915-45.585,25.724-54.726,3.673-8.829,3.278-16.324-1.088-20.772a.673.673,0,1,1,.952-.952c4.788,4.775,5.292,12.9,1.36,22.255-4.081,9.835-25.846,55.012-26.078,55.474a.653.653,0,0,1-.422.354Z",
    transform: "translate(-56.491 -77.808)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13337",
    "data-name": "Path 13337",
    d: "M353.89,239.36c.748,0,10.175,5.2,10.175,5.2",
    transform: "translate(-55.814 -60.153)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13338",
    "data-name": "Path 13338",
    d: "M317.062,196.115c-2.285-.381-14.488-8.38-22.867-14.855s-12.95-7.618-12.95-7.618l-5.713,3.809a11.019,11.019,0,0,1,.762-8.38c2.285-4.19,10.284-8.38,18.283-11.427S311.716,152,317.443,152s7.237,2.285,7.237,5.332,0,12.569-1.9,19.806S317.062,196.115,317.062,196.115Z",
    transform: "translate(-84.228 -91.632)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13339",
    "data-name": "Path 13339",
    d: "M312.983,155.23s-3.523,10.556-7.047,13.726a52.728,52.728,0,0,1-8.788,5.972s-2.108-7.387-7.387-7.387-13.372,3.523-13.372,3.523,0-2.816,6.679-6.339l6.693-3.51,15.481-5.985Z",
    transform: "translate(-83.74 -90.468)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13340",
    "data-name": "Path 13340",
    d: "M312.983,155.23s-3.523,10.556-7.047,13.726a52.728,52.728,0,0,1-8.788,5.972s-2.108-7.387-7.387-7.387-13.372,3.523-13.372,3.523,0-2.816,6.679-6.339l6.693-3.51,15.481-5.985Z",
    transform: "translate(-83.74 -90.468)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13341",
    "data-name": "Path 13341",
    d: "M317.237,196.987h-.122c-2.53-.422-15.059-8.733-23.126-14.964-7.006-5.441-11.332-7.06-12.433-7.414l-5.441,3.632a.762.762,0,0,1-.6.082.68.68,0,0,1-.422-.422,11.6,11.6,0,0,1,.8-8.937c2.721-5.088,12.869-9.522,18.65-11.74,4.543-1.728,15.889-5.754,23.126-5.754,5.319,0,7.917,1.959,7.917,6.013,0,3.129,0,12.665-1.932,19.983s-5.686,18.963-5.727,19.045A.667.667,0,0,1,317.237,196.987ZM281.42,173.154h.163c.19,0,4.816,1.251,13.209,7.74,7.876,6.081,18.854,13.318,22,14.556.816-2.557,3.877-12.243,5.441-18.392,1.891-7.142,1.891-16.542,1.891-19.63,0-2.3-.775-4.652-6.557-4.652-4.924,0-13.168,2.068-22.622,5.673s-16.052,7.672-17.929,11.114a10.284,10.284,0,0,0-.952,6.965l4.924-3.278A.666.666,0,0,1,281.42,173.154Z",
    transform: "translate(-84.403 -91.823)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13342",
    "data-name": "Path 13342",
    d: "M281,150.582a39.028,39.028,0,0,1,9.1,17.371c2.476,10.76,18.038,23.411,21.765,23.411s3.469-18.446,2.231-23.819-6.2-19.861-6.2-19.861S288.087,138.162,281,150.582Z",
    transform: "translate(-82.079 -94.444)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13343",
    "data-name": "Path 13343",
    d: "M312.088,192.213c-4,0-19.915-13-22.432-23.942a38.688,38.688,0,0,0-8.924-17.045.68.68,0,0,1-.109-.816c7.264-12.814,27.574-3.278,27.778-3.17a.68.68,0,0,1,.354.394c.2.585,4.992,14.569,6.23,19.929,1.075,4.707,1.578,20.174-1.279,23.779A2.054,2.054,0,0,1,312.088,192.213Zm-30.022-41.558a39.64,39.64,0,0,1,8.91,17.317c2.476,10.679,17.943,22.881,21.112,22.881,0,0,.258,0,.544-.367,2.313-2.9,2.163-17.684,1.02-22.622s-5.441-17.48-6.094-19.521c-2.272-1.007-19.072-8.039-25.493,2.313Z",
    transform: "translate(-82.247 -94.613)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4335",
    "data-name": "Group 4335",
    transform: "translate(192.65 49.115)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13344",
    "data-name": "Path 13344",
    d: "M312.983,155.23s-3.523,10.556-7.047,13.726a52.728,52.728,0,0,1-8.788,5.972s-2.108-7.387-7.387-7.387-13.372,3.523-13.372,3.523,0-2.816,6.679-6.339l6.693-3.51,15.481-5.985Z",
    transform: "translate(-276.39 -139.583)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13345",
    "data-name": "Path 13345",
    d: "M312.983,155.23s-3.523,10.556-7.047,13.726a52.728,52.728,0,0,1-8.788,5.972s-2.108-7.387-7.387-7.387-13.372,3.523-13.372,3.523,0-2.816,6.679-6.339l6.693-3.51,15.481-5.985Z",
    transform: "translate(-276.39 -139.583)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13346",
    "data-name": "Path 13346",
    d: "M281,150.582a39.028,39.028,0,0,1,9.1,17.371c2.476,10.76,18.038,23.411,21.765,23.411s3.469-18.446,2.231-23.819-6.2-19.861-6.2-19.861S288.087,138.162,281,150.582Z",
    transform: "translate(-274.729 -143.559)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13347",
    "data-name": "Path 13347",
    d: "M312.088,192.213c-4,0-19.915-13-22.432-23.942a38.688,38.688,0,0,0-8.924-17.045.68.68,0,0,1-.109-.816c7.264-12.814,27.574-3.278,27.778-3.17a.68.68,0,0,1,.354.394c.2.585,4.992,14.569,6.23,19.929,1.075,4.707,1.578,20.174-1.279,23.779A2.054,2.054,0,0,1,312.088,192.213Zm-30.022-41.558a39.64,39.64,0,0,1,8.91,17.317c2.476,10.679,17.943,22.881,21.112,22.881,0,0,.258,0,.544-.367,2.313-2.9,2.163-17.684,1.02-22.622s-5.441-17.48-6.094-19.521c-2.272-1.007-19.072-8.039-25.493,2.313Z",
    transform: "translate(-274.897 -143.727)",
    fill: "#2e353a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13348",
    "data-name": "Path 13348",
    d: "M271.549,140.684a144.526,144.526,0,0,0,10.787,22.908c6.285,10.325,18.419,16.174,25.152,13.481s11.318-11.386,9.522-24.853c-.395-2.965-2.979-4.176-3.809-6.8-2.979-9.522-6.013-18.7-7.06-22.2-1.36-4.5-12.134-8.992-23.357-5.849S269.753,129.9,271.549,140.684Z",
    transform: "translate(-85.701 -104.489)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13349",
    "data-name": "Path 13349",
    d: "M307.416,129.421s-4.081,3.034-13.25,1.279-15.481-1.36-15.127,1.061,1.061,5.618,1.061,5.618-11.005-9.522-1.034-12.053c7.183-1.864,11.332.966,13.086,1.36S307.416,129.421,307.416,129.421Z",
    transform: "translate(-84.281 -101.47)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13350",
    "data-name": "Path 13350",
    d: "M307.416,129.421s-4.081,3.034-13.25,1.279-15.481-1.36-15.127,1.061,1.061,5.618,1.061,5.618-11.005-9.522-1.034-12.053c7.183-1.864,11.332.966,13.086,1.36S307.416,129.421,307.416,129.421Z",
    transform: "translate(-84.281 -101.47)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13351",
    "data-name": "Path 13351",
    d: "M303.92,178.645c-7.3,0-16.814-5.972-21.983-14.474a145.266,145.266,0,0,1-10.883-23.044.259.259,0,0,1,0-.109c-2.245-13.4,1.592-21.3,11.712-24.132,11.74-3.292,22.772,1.551,24.2,6.3.49,1.646,1.36,4.53,2.571,8.162,1.36,4.081,2.9,9.019,4.475,14.079a8.583,8.583,0,0,0,1.714,2.721,8.162,8.162,0,0,1,2.122,4.176c2.013,15.113-3.809,23.126-9.93,25.574a10.732,10.732,0,0,1-4,.748ZM272.4,140.692a144.707,144.707,0,0,0,10.692,22.731c6.326,10.379,18.283,15.617,24.336,13.2,5.645-2.258,11.005-9.781,9.087-24.132a7.02,7.02,0,0,0-1.782-3.5,9.523,9.523,0,0,1-1.945-3.251c-1.578-5.047-3.17-10-4.476-14.066-1.156-3.591-2.081-6.489-2.585-8.162-1.143-3.782-11.2-8.556-22.527-5.441C273.843,120.763,270.32,128.136,272.4,140.692Z",
    transform: "translate(-85.886 -104.674)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13352",
    "data-name": "Path 13352",
    d: "M279.376,145.49s-7.2-3.142-7.645,0,2.721,5.441,5.836,6.8a4.462,4.462,0,0,0,4.952-.449",
    transform: "translate(-85.434 -94.481)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13353",
    "data-name": "Path 13353",
    d: "M280.018,153.648a6.38,6.38,0,0,1-2.53-.558c-4.448-1.9-6.666-4.557-6.244-7.468a2.054,2.054,0,0,1,1.075-1.592c2.163-1.211,6.965.83,7.509,1.075a.68.68,0,0,1-.558,1.238c-1.8-.789-5.1-1.782-6.3-1.129a.735.735,0,0,0-.381.6c-.435,3.034,3.21,5.074,5.441,6.026a3.836,3.836,0,0,0,4.2-.313.68.68,0,0,1,.952.966A4.612,4.612,0,0,1,280.018,153.648Z",
    transform: "translate(-85.613 -94.641)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13354",
    "data-name": "Path 13354",
    d: "M300.37,132.095s-8.012-1.9-4.584,8.774c.68,2.109,5.346,4.571,5.346,4.571s-.381,3.428-2.285,3.809",
    transform: "translate(-77.058 -98.852)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13355",
    "data-name": "Path 13355",
    d: "M299.011,150.092a.694.694,0,0,1-.667-.544.68.68,0,0,1,.544-.8c.979-.2,1.483-1.823,1.673-2.721-1.252-.707-4.6-2.721-5.237-4.734-1.279-3.972-1.17-6.8.313-8.407,1.823-1.972,4.924-1.251,5.06-1.224a.68.68,0,0,1,.5.816.667.667,0,0,1-.816.5s-2.476-.558-3.755.83-1.115,3.646,0,7.06c.435,1.36,3.306,3.278,5.006,4.176a.707.707,0,0,1,.354.68c0,.408-.5,3.945-2.829,4.407Z",
    transform: "translate(-77.236 -99.015)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13356",
    "data-name": "Path 13356",
    d: "M296.839,150.674s-5.713,1.143-8-1.524",
    transform: "translate(-79.254 -92.659)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13357",
    "data-name": "Path 13357",
    d: "M294.285,151.831a7.6,7.6,0,0,1-5.781-2.013.68.68,0,1,1,1.034-.884c2,2.34,7.3,1.36,7.359,1.36a.653.653,0,0,1,.789.531.68.68,0,0,1-.531.8A16.7,16.7,0,0,1,294.285,151.831Z",
    transform: "translate(-79.434 -92.823)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13358",
    "data-name": "Path 13358",
    d: "M291,137.263s-4.19-1.524-6.475.381a7.6,7.6,0,0,0-2.721,3.428",
    transform: "translate(-81.791 -97.15)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13359",
    "data-name": "Path 13359",
    d: "M282.019,141.915h-.163a.68.68,0,0,1-.49-.83,8.244,8.244,0,0,1,2.884-3.782c2.557-2.122,6.965-.558,7.142-.49a.666.666,0,0,1,.408.871.68.68,0,0,1-.871.408s-3.85-1.36-5.809.258a7.264,7.264,0,0,0-2.435,3.074.694.694,0,0,1-.667.49Z",
    transform: "translate(-81.955 -97.327)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13360",
    "data-name": "Path 13360",
    d: "M289.219,142.381c.544,1.265.435,2.517-.245,2.8s-1.66-.49-2.2-1.755-.422-2.5.258-2.8S288.688,141.157,289.219,142.381Z",
    transform: "translate(-80.123 -95.752)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13361",
    "data-name": "Path 13361",
    d: "M299.289,137.48c.544,1.252.422,2.5-.245,2.8s-1.673-.5-2.2-1.755-.435-2.517.245-2.8S298.745,136.229,299.289,137.48Z",
    transform: "translate(-76.494 -97.517)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13362",
    "data-name": "Path 13362",
    d: "M279.93,160.441s4.544-3.306,3.714-6.2-2.476-2.9-.816-4.543,2.884-2.489,2.476-4.965-7.033-6.625-4.965-9.1,1.238-5.441,18.2-1.251S326.262,131.9,321.3,125.7s-9.1-7.033-9.1-7.033,9.522-4.081,1.66-8.284S288.2,106.3,278.27,114.108s-7.863,14.433-7.863,14.433-5.373.83-5.8,9.114S279.93,160.441,279.93,160.441Z",
    transform: "translate(-87.987 -107.622)",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13363",
    "data-name": "Path 13363",
    d: "M303.094,128.489a30.594,30.594,0,0,1-10.515-2.34,25.071,25.071,0,0,0-8.244-1.959c-6.57,0-7.931,3.727-7.985,3.891a.449.449,0,0,1-.585.286.462.462,0,0,1-.3-.585c.068-.177,1.592-4.53,8.869-4.53a25.465,25.465,0,0,1,8.556,2.027c4.231,1.51,8.625,3.074,14.147,1.85,2.993-.667,4.748-1.741,5.183-3.17.571-1.836-1.2-3.755-1.211-3.782a.463.463,0,0,1,0-.653.49.49,0,0,1,.667,0c.082.1,2.149,2.34,1.428,4.693-.558,1.782-2.53,3.061-5.877,3.809A19.617,19.617,0,0,1,303.094,128.489Z",
    transform: "translate(-84.081 -103.381)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13364",
    "data-name": "Path 13364",
    d: "M273.576,128.463h0a.476.476,0,0,1-.435-.5c0-.1.8-9.073,8.761-11.087,4.693-1.183,10.121-.3,14.487.408,2.721.449,5.156.843,6.176.449a.476.476,0,0,1,.326.884c-1.252.463-3.632.082-6.652-.408-4.285-.707-9.618-1.564-14.107-.435-7.319,1.864-8.053,10.175-8.067,10.257a.463.463,0,0,1-.49.435Z",
    transform: "translate(-84.911 -104.498)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13365",
    "data-name": "Path 13365",
    d: "M270.566,139.434a.476.476,0,0,1-.258-.082,9.59,9.59,0,0,1-3.36-8.488c.381-5.985,4.979-6.053,5.033-6.053a.476.476,0,0,1,0,.939c-.163,0-3.782.082-4.081,5.169a8.638,8.638,0,0,0,2.952,7.672.449.449,0,0,1,.109.639A.435.435,0,0,1,270.566,139.434Z",
    transform: "translate(-87.167 -101.429)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13366",
    "data-name": "Path 13366",
    d: "M271.93,134.639a.463.463,0,0,1-.422-.272,4.951,4.951,0,0,1-.286-4.081,5.645,5.645,0,0,1,2.993-2.857.449.449,0,0,1,.6.258.463.463,0,0,1-.258.6,4.856,4.856,0,0,0-2.476,2.353,4.081,4.081,0,0,0,.272,3.333.467.467,0,0,1-.422.667Z",
    transform: "translate(-85.714 -100.498)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13367",
    "data-name": "Path 13367",
    d: "M273.019,139.039a.476.476,0,0,1-.381-.2l-1.755-2.449a.468.468,0,0,1,.762-.544L273.4,138.3a.462.462,0,0,1-.109.639.422.422,0,0,1-.272.1Z",
    transform: "translate(-85.756 -97.525)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentionBro);
export default __webpack_public_path__ + "static/media/Mention-bro.65673906ebbe0086d66503c7a127cf92.svg";
export { ForwardRef as ReactComponent };